/*
 * @format
 */

export const getNotificationColour = notificationType => {
  switch (notificationType) {
    case 'siOnline':
    case 'faultResolved':
      return 'green';
    default:
      return 'red';
  }
};

export const getNotificationRoute = notificationType => {
  switch (notificationType) {
    case 'deviceOffline':
    case 'siOnline':
    case 'faultRaised':
    case 'faultResolved':
    case 'lowBattery':
      return 'SystemStatus';
    default:
      return 'Zones';
  }
};
